import EdudoResponse from "../models/edudo-response";
import HttpService from "./http-service";

class SchoolService {
  async getSchoolById(id: number): Promise<School> {
    const response = await HttpService.getJson<EdudoResponse<School>>(`/v1/schools/${id}`);

    return response.data;
  }
}

export default SchoolService;